/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilestoreAttachment } from './FilestoreAttachment';
import {
    FilestoreAttachmentFromJSON,
    FilestoreAttachmentFromJSONTyped,
    FilestoreAttachmentToJSON,
} from './FilestoreAttachment';

/**
 * 
 * @export
 * @interface ClusterAttachmentsResponse
 */
export interface ClusterAttachmentsResponse {
    /**
     * 
     * @type {Array<FilestoreAttachment>}
     * @memberof ClusterAttachmentsResponse
     */
    attachments?: Array<FilestoreAttachment>;
    /**
     * 
     * @type {string}
     * @memberof ClusterAttachmentsResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the ClusterAttachmentsResponse interface.
 */
export function instanceOfClusterAttachmentsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClusterAttachmentsResponseFromJSON(json: any): ClusterAttachmentsResponse {
    return ClusterAttachmentsResponseFromJSONTyped(json, false);
}

export function ClusterAttachmentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterAttachmentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(FilestoreAttachmentFromJSON)),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function ClusterAttachmentsResponseToJSON(value?: ClusterAttachmentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as Array<any>).map(FilestoreAttachmentToJSON)),
        'error': value.error,
    };
}

